import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConvenioService {

  private ENDPOINT = environment.ENDPOINTS.CONVENIO;

  constructor(
    private http: HttpClient
  ) { }

  saveConvenio(data: any) {
    return this.http.post<any>(`${this.ENDPOINT}`, data);
  }

  updateConvenio(data: any) {
    return this.http.put<any>(`${this.ENDPOINT}/${data.id_scct_convenio}`,data );
  }


  getConvenios() {
    return this.http.get<any[]>(`${ this.ENDPOINT }`);
  }
  getConveniosByTransportista(id: number){
    return this.http.get(`${this.ENDPOINT}/porTransportista/${id}`);
  }

}
